import { Banner, Link, StatusIcon, Text } from '@driftt/dds'
import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { RootStateOrAny, useSelector } from 'react-redux'

import { getScenarioTrainingData } from 'api/scenarios'

const TrainingModal = ({ isTesting }: { isTesting?: boolean }) => {
  const [isModalOpen, setIsModalOpen] = useState(true)
  const orgId: string = useSelector(({ user }: RootStateOrAny) => user.orgId)

  const { data: scenarioTrainingData } = useQuery<boolean>({
    queryKey: ['scenarioTrainingData'],
    queryFn: async () => {
      const response = await getScenarioTrainingData({ orgId })
      return response.data
    },
    enabled: true,
  })

  const handleClose = () => {
    setIsModalOpen(false)
  }

  if (!isModalOpen) {
    return null
  }

  return (
    <Banner.Root variant="info" onClose={handleClose}>
      <Banner.Content>
        <StatusIcon variant="info" />
        <Text as="span">
          {scenarioTrainingData ? (
            <>
              <strong>Training in progress.</strong> We are training your
              chatbot on the latest scenario updates.
            </>
          ) : (
            <>
              <strong>Training complete!</strong> Updates to your scenarios are
              now live.
              {!isTesting && ( // Only show the link if not testing
                <>
                  {' '}
                  Test your chatbot{' '}
                  <Link
                    href="/playbooks/testing"
                    css={{ color: '$black', textDecoration: 'underline' }}
                  >
                    here
                  </Link>
                </>
              )}
            </>
          )}
        </Text>
      </Banner.Content>
    </Banner.Root>
  )
}

export default TrainingModal
